import { Box, Grid, Stack, Typography } from '@mui/material';
import { COLORS } from '../../Constants/styles';

import { motion } from 'framer-motion';

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: (i = 1) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.3,
      duration: 0.6,
    },
  }),
};

const ProgramsHeaderSection = () => {
  return (
    <Box maxWidth="xl" mx="auto" px={{ xs: 2, md: 6 }} py={{ xs: 6, md: 8 }} sx={{ backgroundColor: COLORS.white }}>
      <Grid container spacing={4} alignItems="center">
        {/* Left side - Heading & Title */}
        <Grid item xs={12} md={6}>
          <Stack spacing={2} textAlign={{ xs: 'center', md: 'left' }}>
            <motion.div variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true }} custom={1}>
              <Typography variant="h5" component="h6">
                Overview
              </Typography>
            </motion.div>
            <motion.div variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true }} custom={2}>
              <Typography
                variant="h3"
                fontWeight="bold"
                sx={{ color: COLORS.pureBlack }}
              >
                Inspiring joyful childhoods through sport empowering every child to grow, play, and thrive for life
              </Typography>
            </motion.div>
          </Stack>
        </Grid>

        {/* Right side - Description */}
        <Grid item xs={12} md={6}>
          <motion.div variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true }} custom={3}>
            <Typography
              variant="body1"
              color="text.secondary"
              textAlign={{ xs: 'center', md: 'left' }}
            >
              At Grassroots Sports Education & Services, we deliver a comprehensive range of programs designed to nurture children’s development, empower coaches, and strengthen the grassroots sports ecosystem. From structured in-school PE to professional sports education, we create joyful, inclusive, and impactful experiences across schools, communities, and academies.
            </Typography>
          </motion.div>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ProgramsHeaderSection;
